import { useMemo } from 'react'
import styled from 'styled-components'

import { createTradeTableColumnsCompact } from '@root/features/trade/tables/trades-table/ui/trade-table-columns-compact'
import { TradesTable as TradesTable_ } from '@root/features/trade/tables/trades-table/ui/trades-table'

import type { PairAddress, PairModel } from '@root/entities/pair'
import type { TradesTableModel } from '@root/features/trade/tables/trades-table'
import type { ClassNameProps } from '@root/shared/react'

type TradeTableProps = {
  pairAddress: PairAddress
  pair: PairModel
  model: TradesTableModel
  compact?: boolean
} & ClassNameProps

export const TradesTable: React.FC<TradeTableProps> = ({
  className,
  pair,
  pairAddress,
  model,
  compact = false,
}) => {
  const overrideModelColumns = useMemo(() => {
    return createTradeTableColumnsCompact({ pair })
  }, [pair])

  return (
    <Root className={className}>
      <TradesTable_
        model={model}
        pairAddress={pairAddress}
        pair={pair}
        compact={compact}
        overrideModelColumns={compact ? overrideModelColumns : undefined}
      />
    </Root>
  )
}

const Root = styled.div``
